import { useEffect } from "react";
import { useLocation } from "react-router-dom";


function FaroPageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    (window as any).faro?.api?.pushEvent?.("page_view", {
      page: location.pathname,
      referrer: document.referrer,
    });
  }, [location.pathname]);
  return null;
}
export default FaroPageViewTracker;